module.exports = __webpack_public_path__ + "media/asset/images/logo-287abf025fc5d17ac06c4e63ff91e572.png";